import { Typography } from '@mui/material';
import Widget from '@/components/common/widget';
import { useTranslations } from '@/i18n/use-translations';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import FlowPlayoutSettingsPanel from '../flow-playout-settings-panel';

export function MediaControlSettingsWidget({ flow }: { flow: FlowDto }) {
  const t = useTranslations();

  return (
    <Widget title={t('playout.mediaControl.title')} titleVariant="h6">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('playout.mediaControl.configurationIntro')}
      </Typography>
      <FlowPlayoutSettingsPanel flow={flow} />
    </Widget>
  );
}
